import React from 'react';

interface IContext {
    openWithContent: (title: string, content: string) => void;
    openWithUrl: (title: string, url: string) => void;
}

export const PdfViewerDialogContext = React.createContext<IContext>(undefined as any);
